// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import { InputLabel } from './InputLabel';
import { FormInput } from './FormInput';

export interface DateTimeInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  mode?: 'date' | 'datetime';
  required?: boolean;
  error?: string;
  helperText?: string;
  disabled?: boolean;
  id?: string;
  min?: string;
  max?: string;
  'data-testid'?: string;
}

export function DateTimeInput({
  label,
  value,
  onChange,
  mode = 'date',
  required = false,
  error,
  helperText,
  disabled,
  id,
  min,
  max,
  'data-testid': dataTestId,
}: DateTimeInputProps) {
  const inputType = mode === 'datetime' ? 'datetime-local' : 'date';

  return (
    <div className="flex flex-col gap-[6px]">
      <InputLabel htmlFor={id} required={required}>{label}</InputLabel>
      <FormInput
        id={id}
        type={inputType}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={error}
        disabled={disabled}
        min={min}
        max={max}
        data-testid={dataTestId}
      />
      {helperText && !error && (
        <div className="text-[#666] font-sans text-body-03 font-normal leading-normal mt-xs">
          {helperText}
        </div>
      )}
    </div>
  );
}
